import React, { useEffect } from 'react';
import './style.sass';
import { useHistory } from 'react-router-dom'
import { Header } from 'pages/Header'
import { Footer } from 'pages/Footer'
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito'
import { MenuCredito } from 'components/menuCredito'
import { useIsMobile } from 'hooks/useIsMobile'
import { decodeStorage, removeStorage } from 'functions/storageBase64'
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general'
import { ViewTP } from '../PagoT1/ModuloPagoT1';


export default function ThankYouPage() {
    const history = useHistory()

    const { isMobile } = useIsMobile()
    const payCodeSuccess = decodeStorage('payCodeSuccess')

    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.ineum('page', 'Thanks Page Credit-Page')
        window.ineum('meta', 'portal', 'Credito')
    }, [])

    const handleFinalizar = () => {
        removeStorage('payCodeSuccess')
        history.replace(BASE_PATH)
    };

    useEffect(() => {
        if (payCodeSuccess) {
            removeStorage('payCardRelation')
            //window.ineum('meta', 'FolioPagoTarjeta', payCodeSuccess)
        } else {
            history.replace(BASE_PATH)
        }
    }, [])


    let codigo = payCodeSuccess;

    return (
        <>
            {isMobile
                ? isMobile === 'desktop'
                    ? <Header type="complete" />
                    : <HeaderMobileCredito logo="/img/logo-claroshop.png" type="backFullAction" action={handleFinalizar} />
                : null
            }

            <div className="container">

                <div className="contCards">

                    <MenuCredito />

                    <div className="contArrayCards">

                        <ViewTP
                            codigo={codigo}
                            isMobile={isMobile}
                            handleFinalizar={handleFinalizar}
                        />
                        
                    </div>
                </div>
            </div>

            {isMobile
                ? isMobile === 'desktop'
                    ? <Footer type="complete" />
                    : null
                : null
            }
        </>
    )
}